import { Trash2, Loader2 } from "lucide-react";
import Tooltip from "@mui/material/Tooltip";
import { FLOW_TYPE } from "../../constants";
import { Button } from "@/components/ui/button";
import { Header, HeaderSection, HeaderTitle, HeaderActions } from "@/components/eds-shell";

import React from "react";
import Searchbar from "../Searchbar";

/**
 * Buttons Component - Migrated to EDS Components
 * 
 * Phase 5: EDS Migration
 * 
 * This component has been migrated from styled-components buttons
 * to the EDS Button component and EDS Header shell.
 * 
 * Changes:
 * - SaveButton, PreviewButton -> EDS Button outline variant with text labels
 * - PublishButton -> EDS Button default variant with text label
 * - DeleteButton -> EDS Button ghost variant with Trash2 icon
 * - ButtonLoader -> Lucide Loader2 with animate-spin
 * - Inline nav styles -> EDS Header component
 * 
 * Legacy props maintained for backward compatibility.
 */

function Buttons({
  onSave,
  onPreview,
  setVisibleDeploy,
  flowName,
  setFlowName,
  setVisible,
  editFlowName,
  buttonClick,
  isUpdating,
  FlowType,
  isEditable,
  setIsEditable,
  nodes,
  handleSearch,
  searchRef,
  selectedOption,
  setSelectedOption,
  setAtsModalVisibility,
  checkIfMissingAtsValues,
}) {
  return (
    <Header>
      <HeaderSection>
        <HeaderTitle
          editable={editFlowName}
          value={flowName}
          onChange={setFlowName}
        />
      </HeaderSection>
      
      <HeaderSection>
        <Searchbar
          nodes={nodes}
          handleSearch={handleSearch}
          ref={searchRef}
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
          key={"searchbar"}
          id={"searchbar"}
        />
      </HeaderSection>

      {isEditable && (
        <HeaderActions>
          <Tooltip title="Click this button to save the flow">
            <span>
              <Button
                variant="outline"
                onClick={onSave}
                disabled={isUpdating && buttonClick !== "save"}
                className="h-9 min-w-[80px] rounded border border-primary bg-white text-sm font-normal text-primary transition-all duration-300 hover:bg-primary/10 hover:text-primary"
              >
                {isUpdating && buttonClick === "save" ? (
                  <Loader2 className="h-4 w-4 animate-spin" />
                ) : (
                  "Save"
                )}
              </Button>
            </span>
          </Tooltip>
          
          <Tooltip title="Test the flow of your bot">
            <span>
              <Button
                variant="outline"
                onClick={checkIfMissingAtsValues}
                disabled={isUpdating && buttonClick !== "preview"}
                className="h-9 min-w-[100px] rounded border border-primary bg-white text-sm font-normal text-primary transition-all duration-300 hover:bg-primary/10 hover:text-primary"
              >
                {isUpdating && buttonClick === "preview" ? (
                  <Loader2 className="h-4 w-4 animate-spin" />
                ) : (
                  "Test this bot"
                )}
              </Button>
            </span>
          </Tooltip>
          
          {FlowType === FLOW_TYPE.PROFILE && (
            <>
              <Tooltip title="Click this button to deploy the flow">
                <span>
                  <Button
                    variant="default"
                    onClick={() => setVisibleDeploy(true)}
                    disabled={isUpdating && buttonClick !== "publish"}
                    className="h-9 min-w-[80px] rounded border border-primary bg-primary text-sm font-normal text-white transition-all duration-300 hover:bg-primary/90"
                  >
                    {isUpdating && buttonClick === "publish" ? (
                      <Loader2 className="h-4 w-4 animate-spin" />
                    ) : (
                      "DEPLOY"
                    )}
                  </Button>
                </span>
              </Tooltip>
              
              <Tooltip title="Click this button to delete the chat flow changes">
                <span>
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => setVisible(true)}
                    className="h-9 min-w-[50px] rounded-none border-l border-[#00000033] bg-white text-xl text-[#ef4949] transition-all duration-300 hover:bg-[#ef494929] hover:text-[#ef4949]"
                  >
                    <Trash2 className="h-6 w-6" />
                  </Button>
                </span>
              </Tooltip>
            </>
          )}
        </HeaderActions>
      )}
    </Header>
  );
}

export default Buttons;



